// @ts-check
/**
 * A child's birth year + month (出生年月). Set by a parent in settings or a teacher
 * on the class roster; drives age-appropriate defaults such as how 每日听力 is
 * answered. Backend: GET / PUT /api/students/:studentId/birth-ym.
 *
 * @typedef {import('./types').StudentBirthYmResponse} StudentBirthYmResponse
 */

import { apiRequest } from './base';

/**
 * A child's 出生年月, or null when unknown (kids songs asks once).
 * @param {string} studentId
 * @returns {Promise<StudentBirthYmResponse>}
 */
export function getStudentBirthYm(studentId) {
  return apiRequest(`/students/${encodeURIComponent(studentId)}/birth-ym`);
}

/**
 * Save a child's 出生年月, or clear it with null.
 * @param {string} studentId
 * @param {string|null} birthYm - 'YYYY-MM'
 * @returns {Promise<StudentBirthYmResponse>}
 */
export function setStudentBirthYm(studentId, birthYm) {
  return apiRequest(`/students/${encodeURIComponent(studentId)}/birth-ym`, {
    method: 'PUT',
    body: JSON.stringify({ birthYm }),
  });
}
